// PPS progress statuses and BCS progress status have different IDs
// This must match the dbo.Entity table ID
export enum ProgressStatuses{
  Ongoing = 11,
  Pending = 12,
  IRCSigned = 13, 
  Invoiced = 14,
  Completed = 15, 
  Paid = 16,
  InPrep = 17
}